import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../../@types/RootState';

const initialState = 0;

const slice = createSlice({
  name: 'ipa.strategy.rules.table.totalElements',
  initialState,
  reducers: {
    SET_RULES_TOTAL_ELEMENTS: (_state, action: PayloadAction<number>) => {
      return action.payload;
    },
  },
});

export const selectorRulesDataTotalElements = (state: RootState) => {
  return state.ipa.strategy.rules.table.totalElements;
};

export const { SET_RULES_TOTAL_ELEMENTS } = slice.actions;

export default slice.reducer;
